import React from "react";
import { array, string, bool } from "prop-types";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";

import "./organism1.m.css";

const Organism1 = ({ storyList, className = "", updatedFont = false }) => {
  if (!(storyList && storyList.length)) {
    return null;
  }

  return (
    <div styleName="base" className={className}>
      {storyList.splice(0, 1).map(({ story }, index) => (
        <CustomStoryCard2
          story={story}
          key={index}
          headlineType={2}
          subHeadlineType={6}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          isMetaDataShown={false}
          isSection={false}
          isExcerpt={true}
          widths={global.deviceWidth < 876 ? [350] : [600]}
          className="first-story"
          updatedFont={updatedFont}
        />
      ))}
      <div styleName="medium-storycard">
        {storyList.splice(0, storyList.length).map(({ story }, index) => (
          <CustomStoryCard4
            story={story}
            key={index}
            headlineType={21}
            widths={global.deviceWidth > 1263 ? [300] : [150]}
            updatedFont={updatedFont}
            changeAspectRatio={global.deviceWidth > 875 ? [16, 9] : [4, 3]}
            src="six-stories-1ad-tag-search"
          />
        ))}
      </div>
    </div>
  );
};

Organism1.propTypes = {
  storyList: array.isRequired,
  className: string,
  updatedFont: bool
};

export default Organism1;
